import { render } from "./signUp.vue?vue&type=template&id=4b30a1e8&scoped=true"
import script from "./signUp.vue?vue&type=script&lang=js"
export * from "./signUp.vue?vue&type=script&lang=js"

import "./signUp.vue?vue&type=style&index=0&id=4b30a1e8&lang=less&scoped=true"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b30a1e8"]])

export default __exports__